import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import ItemProducto from "../../widgets/item_producto";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faThLarge} from "@fortawesome/free-solid-svg-icons";



function RelatedAds({ products_relations }) {

    const [arrayRelated, setArrayRelated] = useState([]);

    useEffect(() => {
        if (products_relations) {
            setArrayRelated(products_relations);
        }
    }, [products_relations]);

    const updateFavoriteStatus = (productId, isFavorite) => {
        const updatedProducts = arrayRelated.map(product =>
            product.id === productId ? { ...product, is_favorite: isFavorite ? 1 : 0 } : product
        );

        setArrayRelated(updatedProducts);
    };

    if (!arrayRelated.length) return null;

    return (
        <>
            <section className="prod-related-section">
                <div className="container">
                    {/* Section Header */}
                    <div className="prod-related-header">
                        <div className="flex items-center gap-2">
                            <FontAwesomeIcon icon={faThLarge} className="text-ecoprimary1"/>
                            <h2 className="prod-related-title">
                                Productos relacionados
                            </h2>
                        </div>
                        <div className="prod-related-line"></div>
                    </div>

                    {/* Products Grid */}
                    <div className="row">
                        {
                            arrayRelated.map((product, index) =>
                                <div className="col-6 col-md-4 col-lg-2 mb-3 p-2" key={index}>
                                    <ItemProducto
                                        product={product}
                                        updateFavoriteStatus={updateFavoriteStatus}
                                    />
                                </div>
                            )
                        }
                    </div>

                </div>
            </section>
        </>
    );
}

const mapStateToProps = state => ({
    products_relations: state.Product.products_relations,
})

export default connect(mapStateToProps, {})(RelatedAds)